import { render, staticRenderFns } from "./SvTermsOfUse.vue?vue&type=template&id=d5b908d8&scoped=true"
import script from "./SvTermsOfUse.vue?vue&type=script&lang=js"
export * from "./SvTermsOfUse.vue?vue&type=script&lang=js"
function injectStyles (context) {
  
  
}

/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "d5b908d8",
  null
  ,true
)

export default component.exports